<template>
  <div :class="[`${direction}Stepper`]">
    <div class="progressBarBackground">
      <div class="progressValue" :style="progressStyle"></div>
    </div>

    <ul class="stepperList">
      <li v-for="(label, index) in stepList" :key="index" class="stepperItem" :style="labelItemWidth" @click="selectItem(index)">
        <label class="stepperItemLabel">
          {{ $t(label) }}
        </label>
        <div class="stepperItemNumber" :style="itemStyle(index)"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StepperComponent',
  props: {
    currentStep: {
      type: Number,
      required: true
    },

    stepList: {
      type: Array,
      required: true
    },

    disabledSteps: {
      type: Array,
      required: true,
      default: () => []
    },

    activeColor: {
      type: String,
      default: '#8b69a9'
    },

    direction: {
      type: String,
      default: 'horizontal'
    }
  },

  computed: {
    stepItemWidth() {
      return 100 / this.stepList.length
    },

    labelItemWidth() {
      return this.direction === 'vertical' ? '' : { width: `${this.stepItemWidth}%` }
    },

    progressStyle() {
      const oStyle = {
        'background-color': this.activeColor
      }
      if (this.direction === 'vertical') {
        oStyle.height = `${this.stepItemWidth * this.currentStep}%`
      } else {
        oStyle.width = `${this.stepItemWidth * this.currentStep}%`
      }
      return oStyle
    }
  },

  methods: {
    itemStyle(index) {
      let style = ''

      if (index < this.currentStep) {
        style = {
          'background-color': this.activeColor,
          color: this.activeColor
        }
      }

      return style
    },

    selectItem(itemIndex) {
      if (this.disabledSteps.length > 0 && this.disabledSteps[itemIndex] === false) {
        this.$emit('selectedItem', itemIndex + 1)
      }
    }
  }
}
</script>

<style lang="scss">
$text-color: #8b69a9;
$background-color: #ddd;

/*horizontal progressbar styling*/

.horizontalStepper {
  position: relative;
  padding: 10px 0;
  z-index: 2;
}

.horizontalStepper .progressBarBackground {
  position: absolute;
  width: 100%;
  height: 4px;
  bottom: 22px;
  background-color: $background-color;
}

.horizontalStepper .progressValue {
  position: inherit;
  top: 0;
  left: 0;
  height: inherit;
}

.stepperList {
  position: relative;
  display: -webkit-flex;
  display: flex;
  cursor: pointer;
  user-select: none;
}

.stepperList,
.stepperItem {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.horizontalStepper .stepperList {
  justify-content: space-around;
  text-align: center;
}

.stepperItemLabel {
  font-size: 12px;
  color: $text-color;
}

.stepperItemNumber {
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  border-radius: 50%;
  color: $text-color;
  background-color: $background-color;
}

.horizontalStepper .stepperItemLabel {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.horizontalStepper .stepperItemNumber {
  margin: 5px auto;
}

/*vertical progressbar styling*/

.verticalStepper {
  position: relative;
  padding: 0;
  z-index: 2;
}

.verticalStepper .progressBarBackground {
  position: absolute;
  width: 4px;
  height: 100%;
  top: 0;
  left: 15px;
  background-color: $background-color;
}

.verticalStepper .progressValue {
  position: absolute;
  top: 0;
  left: 0;
  width: inherit;
}

.verticalStepper .stepperList {
  height: inherit;
  flex-direction: column;
  padding-left: 8px;
}

.verticalStepper .stepperItem {
  display: -webkit-flex;
  display: flex;
  height: 25%;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 18px;
}

.verticalStepper .stepperItemLabel {
  position: absolute;
  order: 1;
  padding-left: 34px;
}
</style>
